// extracted by mini-css-extract-plugin
export var container = "_vn-0";
export var table = "_vn-2";
export var tableWrapper = "_vn-1";